import React from "react";
import {
  FaPercentage,
  FaClipboard,
  FaCalendarAlt,
  FaRedoAlt,
} from "react-icons/fa";
import { MdAttachMoney, MdShoppingCart } from "react-icons/md";

const PromocodeInfo = ({ promoData }) => {
  const handleCopyPromoCode = () => {
    navigator.clipboard.writeText(promoData.promo_code);
    alert("Promo code copied!");
  };

  return (
    <div className="bg-white rounded-lg px-3 py-6 w-full max-w-md mx-auto">
      <div className="flex justify-between items-center mb-4 border-b pb-4">
        <h2 className="text-xl font-bold text-gray-800">Promo Code Details</h2>
        <span
          className={`px-2 py-1 rounded-full text-sm font-semibold ${
            promoData?.active
              ? "bg-green-100 text-green-600"
              : "bg-red-100 text-red-600"
          }`}
        >
          {promoData?.active ? "Active" : "Inactive"}
        </span>
      </div>

      <div className="space-y-6">
        {/* Promo Code Section */}
        <div className="bg-gray-100 p-4 rounded-lg flex justify-between items-center">
          <div className="text-lg font-bold text-[#145388]">
            {promoData?.promo_code}
          </div>
          <button
            onClick={handleCopyPromoCode}
            className="text-sm bg-[#145388] text-white px-3 py-1 rounded-lg flex items-center"
          >
            <FaClipboard className="mr-2" /> Copy
          </button>
        </div>

        <div className="flex items-center">
          <span className="ml-2 text-gray-700">{promoData?.description}%</span>
        </div>
        {/* Discount Section */}
        <div className="flex items-center">
          <FaPercentage className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Discount:</span>
          <span className="ml-2 text-gray-900">
            {promoData?.discount?.$numberDecimal}%
          </span>
        </div>

        {/* Discount Type Section */}
        <div className="flex items-center">
          <MdAttachMoney className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Discount Type:</span>
          <span className="ml-2 text-gray-900">{promoData?.discount_type}</span>
        </div>

        {/* Promo For */}
        <div className="flex items-center">
          <MdShoppingCart className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Promo For:</span>
          <span className="ml-2 text-gray-900">{promoData?.promo_for}</span>
        </div>

        {/* Start Date */}
        <div className="flex items-center">
          <FaCalendarAlt className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Start Date:</span>
          <span className="ml-2 text-gray-900">
            {new Date(promoData?.start_date).toLocaleDateString()}
          </span>
        </div>

        {/* End Date */}
        <div className="flex items-center">
          <FaCalendarAlt className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">End Date:</span>
          <span className="ml-2 text-gray-900">
            {new Date(promoData?.end_date).toLocaleDateString()}
          </span>
        </div>

        {/* Repeat Section */}
        <div className="flex items-center">
          <FaRedoAlt className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Repeat:</span>
          <span className="ml-2 text-gray-900">{promoData?.repeat}</span>
        </div>

        {/* Apply Offer After Orders */}
        <div className="flex items-center">
          <MdShoppingCart className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">
            Apply Offer After Orders:
          </span>
          <span className="ml-2 text-gray-900">
            {promoData?.apply_offer_after_orders}
          </span>
        </div>

        {/* Required Uses */}
        <div className="flex items-center">
          <FaPercentage className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">Required Uses:</span>
          <span className="ml-2 text-gray-900">{promoData?.required_uses}</span>
        </div>

        {/* Minimum Items in Cart */}
        <div className="flex items-center">
          <MdShoppingCart className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">
            Minimum Items in Cart:
          </span>
          <span className="ml-2 text-gray-900">
            {promoData?.min_item_on_cart}
          </span>
        </div>

        {/* Minimum Order Amount */}
        <div className="flex items-center">
          <MdAttachMoney className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">
            Minimum Order Amount:
          </span>
          <span className="ml-2 text-gray-900">
            ${promoData?.min_order_amount?.$numberDecimal}
          </span>
        </div>

        {/* Max Discount Amount */}
        <div className="flex items-center">
          <MdAttachMoney className="text-gray-500 mr-2" />
          <span className="font-semibold text-gray-700">
            Max Discount Amount:
          </span>
          <span className="ml-2 text-gray-900">
            ${promoData?.max_discount_amount?.$numberDecimal}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PromocodeInfo;
